<template>
    <div id="app" v-if="loaded">
        <router-view/>
    </div>
    <div class="app-container" v-else v-loading="!loaded">

    </div>
</template>

<script>
    import api from '@/api/api'
    import { mapGetters } from 'vuex'
    import { logout } from '@/helpers/helpers'
    export default {
        name: 'App',
        computed: {
            ...mapGetters({
                authToken: 'getAuthToken',
            })
        },
        data () {
            return {
                loaded: false
            }
        },
        watch: {
            authToken () {
                if (!this.authToken)
                    this.logout()
            }
        },
        async created () {
            setTimeout(() => { this.loaded = true }, 2000)
            if (this.authToken)
                await this.$store.dispatch('fetchSelf')
        },
        methods: {
            logout
        }
    }
</script>

<style>
	::-webkit-scrollbar {
	    width: 5px;
	}

	::-webkit-scrollbar-track {
	    background: #f1f1f1; 
	}

	::-webkit-scrollbar-thumb {
	    background: #888; 
	}

	::-webkit-scrollbar-thumb:hover {
	    background: #555; 
    }
    
    #app {
        font-family: 'Century Gothic', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        height: 100%;
    }
    
    body, 
    html {
        height: 100%;
    }

    .app-container {
        margin-top: 50px;
    }

    body {
        margin: 0;
        font-size: 14px;
        background-color: whitesmoke;
    }
    
    h1 {
        margin-top: 0;
    }
    .table-button {
        width: 30px !important; 
        height: 30px !important; 
        padding: 0 !important; 
        margin: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue